import '../Styles/SearchForm.css';

const SearchForm = (props) => {
    return (
        <> 
            <div>
                <center>
                <div className="link">Download Android App <b>HannanMaxIG:</b> (1) PlayStore <a className="link-red" href="https://play.google.com/store/apps/details?id=instant.saver.hannanmaxig" color="white">Click here</a> | (2) Drive <a className="link-red" href="https://www.hannanmax.com/HannanMaxIG/HannanMaxIG.apk" color="white">Click here</a></div>
                </center>
                <form action="" className="input-form" onSubmit={props.submitHandler}>
                    <input
                        type="text"
                        className="inputBox"
                        onChange={props.onChangehandler}
                        placeholder={props.placeholder}
                    />
                    <input type="submit" className="submitBtn" value="Search" />
                </form>
            </div>
        </>) 
}

export default SearchForm;